import { MedicalPaOrdersAuthStatus } from "../../../medonc/enums/medicalPaOrdersAuthStatus";
import { DocumentTypesForOrder } from "../../enums/documentTypes";

export interface DocumentInfo {
  documentName: string;
  documentType: DocumentTypesForOrder;
}

export interface StatusDocumentMapping {
  [key: string]: {
    documents: DocumentInfo[];
  };
}

// Map structure mapping auth status to document requirements
export const statusToDocumentMap: StatusDocumentMapping = {
  [MedicalPaOrdersAuthStatus.AuthByRISA]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.FILLED_FORM,
        documentType: DocumentTypesForOrder.FILLED_FORM,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.DeniedByRISA]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.FILLED_FORM,
        documentType: DocumentTypesForOrder.FILLED_FORM,
      },
      {
        documentName: DocumentTypesForOrder.DENIAL_LETTER,
        documentType: DocumentTypesForOrder.DENIAL_LETTER,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.NoAuthRequired]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.NAR_LETTER,
        documentType: DocumentTypesForOrder.NAR_LETTER,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.Pending]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.FILLED_FORM,
        documentType: DocumentTypesForOrder.FILLED_FORM,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.AuthOnFile]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.APPROVAL_LETTER,
        documentType: DocumentTypesForOrder.APPROVAL_LETTER,
      },
      {
        documentName: DocumentTypesForOrder.AUTH_LETTER,
        documentType: DocumentTypesForOrder.AUTH_LETTER,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.DenialAfterQuery]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.FILLED_FORM,
        documentType: DocumentTypesForOrder.FILLED_FORM,
      },
      {
        documentName: DocumentTypesForOrder.DENIAL_LETTER,
        documentType: DocumentTypesForOrder.DENIAL_LETTER,
      },
    ],
  },
  [MedicalPaOrdersAuthStatus.ExistingDenial]: {
    documents: [
      {
        documentName: DocumentTypesForOrder.FILLED_FORM,
        documentType: DocumentTypesForOrder.FILLED_FORM,
      },
      {
        documentName: DocumentTypesForOrder.DENIAL_LETTER,
        documentType: DocumentTypesForOrder.DENIAL_LETTER,
      },
    ],
  },
};

export const DocumentUploadModalTitleMap: { [key: string]: string } = {
  [DocumentTypesForOrder.FILLED_FORM]: "Upload filled form",
  [DocumentTypesForOrder.APPROVAL_LETTER]: "Upload approval letter",
  [DocumentTypesForOrder.DENIAL_LETTER]: "Upload denial letter",
  [DocumentTypesForOrder.NAR_LETTER]: "Upload NAR letter",
  [DocumentTypesForOrder.AUTH_LETTER]: "Upload auth letter",
};

export const DocumentViewerTitleMap: { [key: string]: string } = {
  [DocumentTypesForOrder.FILLED_FORM]: "Filled form",
  [DocumentTypesForOrder.APPROVAL_LETTER]: "Approval letter",
  [DocumentTypesForOrder.DENIAL_LETTER]: "Denial letter",
  [DocumentTypesForOrder.NAR_LETTER]: "NAR letter",
  [DocumentTypesForOrder.AUTH_LETTER]: "Auth letter",
};

export const getDocumentsForStatus = (status: string): DocumentInfo[] => {
  return statusToDocumentMap[status]?.documents || [];
};

export const getDocumentNameForStatusAndDocType = (
  status: string,
  docType: string,
): string => {
  return (
    statusToDocumentMap[status]?.documents?.find(
      (doc) => doc.documentType === docType,
    )?.documentName || ""
  );
};

export const getDocumentTitleByDocType = (docType: string): string => {
  return DocumentUploadModalTitleMap[docType] || "";
};

export const getViewerDocumentTitleByDocType = (docType: string): string => {
  return DocumentViewerTitleMap[docType] || "";
};
